import { useState } from 'react';

function FAQ2() {
  const [openIndex, setOpenIndex] = useState(0); // First question is open by default

  const faqs = [
    {
      question: "What is MajesticVUSA Corporate Car Service NYC? ",
      answer: "MajesticVUSA Corporate Car Service NYC is a premium transportation solution for business executives, VIP clients, and corporate events. We provide luxury sedans, SUVs, and executive vans with professional chauffeurs to ensure safe, punctual, and comfortable travel in New York City."
    },
    {
  "question": "Which airports does MajesticVUSA serve in NYC?",
  "answer": "We provide airport car service NYC for all major airports:\n● JFK Airport\n● LaGuardia (LGA) Airport\n● Newark (EWR) Airport\n\nOur chauffeurs track your flight in real-time and provide timely pickups and drop-offs."
},
    {
      question: "Can I book an hourly corporate limo service?",
      answer: "Yes! MajesticVUSA offers flexible hourly corporate limo services in NYC for meetings, events, or city travel. You can also book full-day executive car service for conferences, corporate roadshows, or extended business trips."
    },
    {
      question: "Is MajesticVUSA safe and reliable?",
      answer: "Yes. Safety and reliability are our top priorities. All chauffeurs are licensed, trained, and insured, and all vehicles undergo regular maintenance and safety checks."
    },
    {
      question: "Is MajesticVUSA available 24/7?",
      answer: "Yes. Our corporate car service NYC is available 24/7 for airport pickups, last-minute trips, or pre-scheduled corporate travel. "
    },
    
    
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-12 sm:py-16 px-4 sm:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-start">
          {/* Left Side - Content - Mobile: Second, Desktop: Left */}
          <div className="order-2 lg:order-1">
            {/* Mobile: Show image first */}
            <div className="w-full mb-6 lg:hidden">
              <img 
                src="https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png" 
                alt="Quality and Comfort in Black Car Services" 
                className="w-full h-64 sm:h-80 object-cover rounded-lg shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-64 sm:h-80 bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
            
            <div className="flex items-center mb-4">
              <h3 className="text-lg sm:text-xl font-semibold">Frequently Asked Questions</h3>
            </div>
            <h2 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6 leading-tight">
              Flexible Corporate Limo & Hourly Services 
            </h2>
            <p className="text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed text-gray-900">
              Need flexibility? Our hourly corporate limo service NYC allows you to book vehicles for 
meetings, airport pickups, or full-day business travel. We also provide long-distance executive 
car service NYC, including trips to New Jersey, Connecticut, and Pennsylvania. 
            </p>
            
            {/* Desktop: Show image after text */}
            <div className="w-full hidden lg:block">
              <img 
                src="https://empirelimotransfer.com/wp-content/uploads/elementor/thumbs/Quality-and-Comfort-in-Black-Car-Services-rfbp7tg55qeyb9siklds8nx4852mhwtastvj8qkxq0.png" 
                alt="Quality and Comfort in Black Car Services" 
                className="w-full h-64 sm:h-80 lg:h-[320px] object-cover rounded-lg shadow-lg"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = '<div class="w-full h-64 sm:h-80 lg:h-[280px] bg-gradient-to-br from-gray-200 to-gray-300 rounded-lg flex items-center justify-center"><span class="text-6xl">🚗</span></div>';
                }}
              />
            </div>
          </div>

          {/* Right Side - FAQ Accordion - Mobile: First, Desktop: Right */}
          <div className="space-y-4 order-1 lg:order-2">
            {faqs.map((faq, index) => (
              <div key={index} className="border border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFAQ(index)}
                  className={`w-full px-4 sm:px-6 py-3 sm:py-4 text-left flex justify-between items-center transition-colors ${
                    openIndex === index 
                      ? 'bg-black text-white' 
                      : 'bg-gray-50 text-gray-900 hover:bg-gray-100'
                  }`}
                >
                  <span className="font-semibold pr-4 text-sm sm:text-base">{faq.question}</span>
                  <span className="flex-shrink-0">
                    {openIndex === index ? (
                      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                      </svg>
                    ) : (
                      <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    )}
                  </span>
                </button>
                {openIndex === index && (
                  <div className="px-4 sm:px-6 py-3 sm:py-4 bg-white border-t border-gray-200">
                    <p className="text-gray-900 leading-relaxed text-sm sm:text-base">
                      {faq.answer.split('**').map((part, i) => 
                        i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                      )}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ2;












